import DateFnsUtils from '@date-io/date-fns';
import {
  Card,
  Button,
  CardContent,
  CardHeader,
  createMuiTheme,
  Divider,
  Grid,
  TextField,
  Typography,
  Snackbar,
  Backdrop,
  CircularProgress, Stepper, Step, StepLabel, FormControlLabel, FormLabel, FormControl, FormGroup, FormHelperText, ButtonGroup, Checkbox, Dialog, DialogContent
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import 'date-fns';
import trLocale from 'date-fns/locale/tr';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import Alert from 'src/components/Alert';
import { getUser } from 'src/utils/Common';
import { setTask } from '../../store/actions/taskActions';
import Page from 'src/components/Page';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import FilePopup from 'src/components/FilePopup';
import moment from 'moment';


const useStyles = makeStyles(theme => ({
  root: {  
    "& .MuiStepIcon-active": { color: "#9E7676" },
    "& .MuiStepIcon-completed": { color: "#C8DBBE" },
    "& .Mui-disabled .MuiStepIcon-root": { color: "#7B8FA1" }
  },
  dividerDegisim: {
    backgroundColor: '#1D3343'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  fieldsComboDegisim: {
    margin: theme.spacing(0),
    display: 'flex'
  }
}));

const Degisimsiyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: Degisimsiyah,
      main: Degisimsiyah,
      light: Degisimsiyah
    }
  }
});
const localeMap = {
  tr: trLocale
};

function CompensationForm({ className, ReceiptNo }) {
  const locale = localStorage.getItem('i18nextLng');
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const [loading, setLoading] = useState(false);
  const SessionUser = getUser();
  const [activeStep, setActiveStep] = React.useState(0);
  const [ManufacturingFault, setManufacturingFault] = useState('');
  const [EngineerFindings, setEngineerFindings] = useState('');
  const [DamageDetails, setDamageDetails] = useState('')
  const [OtherInfo, setOtherInfo] = useState('')
  const [DiaryDate, setDiaryDate] = useState(moment(DiaryDate).toISOString('DD-MM-YYYY HH:mm:ss'));
  const [GlobalClaimPaidDate, setGlobalClaimPaidDate] = useState('1900-01-01T00:00:00Z');
  const [Reserve,setReserve] = useState(0);
  const [AmountPaid,setAmountPaid] = useState(0);
  const [AmountRequested,setAmountRequested] = useState(0);
  const [ASIStatus,setASIStatus] = useState(0);
  const [GlobalClaimType,setGlobalClaimType] = useState(0);
  const [ASINote, setASINote] = useState('');
  const [Summary, setSummary] = useState('');
  const [formRequired, setFormRequired] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [openFile, setOpenFile] = useState(false);
  const [DosyaTipi, setDosyaTipi] = useState(1);
  const [DosyaIsmi, setDosyaIsmi] = useState('');
  const [compensation,setCompensation] = useState([]);
  const [files,setFiles] = useState([]);
  const stepColor = useStyles();
  const [damagePhotoCount,setDamagePhotoCount] = useState(0);
  const [serialNumberPlateCount,setserialNumberPlateCount] = useState(0);
  const [defectPhotoCount,setdefectPhotoCount] = useState(0);
  
  
  
  const steps = getSteps();
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };



  const SaveCompensation = () => {
    const dataBody = {
      WorkOrderId: ReceiptNo,
      ManufacturingFault: ManufacturingFault,
      EngineerFindings: EngineerFindings,
      DamageDetails: DamageDetails,
      OtherInfo: OtherInfo,
      DiaryDate: DiaryDate,
      GlobalClaimPaidDate: GlobalClaimPaidDate,
      Reserve: Reserve,
      AmountPaid: AmountPaid,
      AmountRequested: AmountRequested,
      ASIStatusId: ASIStatus,
      ASINote: ASINote,
      GlobalClaimTypeId: GlobalClaimType,
      FormRequired: formRequired,
      Confirmed: confirmed,
      Summary: Summary
    };

    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetCompensation', dataBody, dataConfig)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        if (res[0].ErrorCode === 0) {
            setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t('success_message')
          });
          setUyariTip('success');
          setUyari(true);
          setLoading(false);
        } else {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: res[0].ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
          setLoading(false);
        }
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblMustFieldControl')
        });
        setUyariTip('error');
        setUyari(true);
        setLoading(false);
      });
  }


  const getCompensation = () => {
    setLoading(true);
    axios
      .get(
        `/GetCompensationSS/${ReceiptNo || 0}`
      )
      .then(response => {
        if(response.data.length > 0 && response.data != ""){
            setCompensation(response.data);
            setManufacturingFault(response.data[0].ManufacturingFault);
            setEngineerFindings(response.data[0].EngineerFindings);
            setDamageDetails(response.data[0].DamageDetails);
            setOtherInfo(response.data[0].OtherInfo);
            setDiaryDate(response.data[0].DiaryDate || 0);
            setGlobalClaimPaidDate(response.data[0].GlobalClaimPaidDate || 0);
            setASINote(response.data[0].ASINote || '');
            setReserve(response.data[0].Reserve || 0);
            setAmountPaid(response.data[0].AmountPaid || 0);
            setAmountRequested(response.data[0].AmountRequested || 0);
            setASIStatus(response.data[0].ASIStatusId || 0);
            setGlobalClaimType(response.data[0].GlobalClaimTypeId || 0);
            setFormRequired(response.data[0].FormRequired || false);
            setConfirmed(response.data[0].Confirmed || false);
            setSummary(response.data[0].Summary || '');
        }else{
            setCompensation([]); //no data
        }
        setLoading(false);
      })
      .catch(error => {
        setUyariTip('error');
        setUyari(true);
        setLoading(false);
      });
  };

  const getFilesForCompensation = () => {
    axios
      .get(
        `/GetFilesForCompensation/${ReceiptNo || 0}`
      )
      .then(response => {
        if(response.data.length > 0 && response.data != ""){
            setFiles(response.data);
        }else{
            setFiles([]); //no data
        }
      })
      .catch(error => {
        setUyariTip('error');
        setUyari(true);
      });
  };

  useEffect(()=>{
    getCompensation();
    getFilesForCompensation();
  }, [locale])


  function getSteps() {
      return [t('lblDefineTheSituation'), t('lblAttachments'),t('lblSummary')];
  }

  const handleNext = () => {
    setDamagePhotoCount(files.find(i => i.WorkOrderId == ReceiptNo && i.Type == 2 && i.TypeCount > 0)?.TypeCount);
    setserialNumberPlateCount(files.find(i => i.WorkOrderId == ReceiptNo && i.Type == 3 && i.TypeCount > 0)?.TypeCount);
    setdefectPhotoCount(files.find(i => i.WorkOrderId == ReceiptNo && i.Type == 4 && i.TypeCount > 0)?.TypeCount)

    setRequired(true)
    if(activeStep === 0){
      if (ManufacturingFault === '' || EngineerFindings === '' || DamageDetails === '')
      {
        setActiveStep((prevActiveStep) => prevActiveStep);
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblManufacturingFaultError')
        });
        setUyariTip('error');
        setUyari(true);
        setLoading(false);
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      getFilesForCompensation();
    }
    if(activeStep === 1){
      if((damagePhotoCount === undefined || damagePhotoCount < 1) ||
      (serialNumberPlateCount === undefined || serialNumberPlateCount < 1) ||
      (defectPhotoCount === undefined || defectPhotoCount < 1))
      {
        setActiveStep((prevActiveStep) => prevActiveStep);
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblAttachFileError')
        });
        setUyariTip('error');
        setUyari(true);
        setLoading(false);
      }
      else{
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    }
    if (activeStep === 2) {
      SaveCompensation();
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
    
  };

  const handleBack = () => {

    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const [
    required,
    setRequired
  ] = React.useState(false);

  const handleFileOpen = (fileType) => {
    setDosyaTipi(fileType)
    if(fileType == 2) {setDosyaIsmi(t('lblDamagePhoto'))} 
    if(fileType == 3) {setDosyaIsmi(t('lblSerialNumberPlate'))} 
    if(fileType == 4) {setDosyaIsmi(t('lblDefectPhoto'))} 

    if (DosyaTipi === undefined) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('Dosya_sec_error')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setOpenFile(true);
  };

  const handleFileClose = () => {
    setOpenFile(false);
  };

  function CompFiles(files){
    setFiles(files);
    setDamagePhotoCount(files.find(i => i.WorkOrderId == ReceiptNo && i.Type == 2 && i.TypeCount > 0)?.TypeCount);
    setserialNumberPlateCount(files.find(i => i.WorkOrderId == ReceiptNo && i.Type == 3 && i.TypeCount > 0)?.TypeCount);
    setdefectPhotoCount(files.find(i => i.WorkOrderId == ReceiptNo && i.Type == 4 && i.TypeCount > 0)?.TypeCount)
  }
  
  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return <Grid container direction='row' justify='space-between' spacing={3}>
          <Grid item xs={12} sm={12} lg={12}>
            <FormControl component="fieldset">
                <FormLabel component="legend">{t('lblIsManufacturingFault')}</FormLabel>
                <FormGroup aria-label="position" row>
                <FormControlLabel
                    value="yes"
                    control={<Checkbox checked={ManufacturingFault === "Yes"} onChange={() => setManufacturingFault("Yes")}/>}
                    label={t('lblYesOption')}
                    labelPlacement="start"
                />
                <FormControlLabel 
                    value="no"
                    control={<Checkbox checked={ManufacturingFault === "No"} onChange={() => setManufacturingFault("No")}/>}
                    label={t('lblNoOption')}
                    labelPlacement="start"
                />
                <FormControlLabel
                    value="notsure"
                    control={<Checkbox checked={ManufacturingFault === "Not Sure"} onChange={() => setManufacturingFault("Not Sure")}/>}
                    label={t('lblNotSure')}
                    labelPlacement="start"
                />
                </FormGroup>
            </FormControl>
          </Grid>
            <Grid item xs={12} sm={12} lg={12}>
                    <TextField
                    value={EngineerFindings}
                    onChange={(e)=>setEngineerFindings(e.target.value)}
                    required
                    variant="outlined"
                    fullWidth
                    error={EngineerFindings != '' ? false : required}
                    id="outlined-multiline-flexible"
                    placeholder={t('lblEngineerFindings')}
                    multiline
                    maxRows={4} ></TextField>
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
                    <TextField
                    value={DamageDetails}
                    onChange={(e)=>setDamageDetails(e.target.value)}
                    required
                    variant="outlined"
                    fullWidth
                    error={DamageDetails != '' ? false : required}
                    id="outlined-multiline-flexible"
                    placeholder={t('lblDetailsOfDamage')}
                    multiline
                    maxRows={4} ></TextField>
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
                    <TextField
                    value={OtherInfo}
                    onChange={(e)=>setOtherInfo(e.target.value)}
                    style={{marginBottom:'10px'}}
                    variant="outlined"
                    fullWidth
                    id="outlined-multiline-flexible"
                    placeholder={t('lblAnyOtherRelevantInformation')}
                    multiline
                    maxRows={4} ></TextField>
            </Grid>
        </Grid >;
      case 1: 
        return <Grid container direction='row' spacing={2}>
          <Grid item xs={12} sm={12} lg={12}>
              <Typography variant="overline" display="block" gutterBottom>{t('lblAttachFileMessage')}</Typography>
          </Grid>
                <Grid item xs={12} sm={4} lg={4}> 
                  <Button onClick={() => handleFileOpen(2)} style={{height:'100px',width:'250px', backgroundColor:'#73A9AD', color:'white'}}>
                      <AttachFileIcon></AttachFileIcon>{t('lblDamagePhoto')}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={4} lg={4}> 
                    <Button onClick={() => handleFileOpen(3)} style={{height:'100px',width:'250px', backgroundColor:'#73A9AD', color:'white'}}>
                        <AttachFileIcon></AttachFileIcon>{t('lblSerialNumberPlate')}
                    </Button>
                </Grid>
                <Grid item xs={12} sm={4} lg={4}>
                    <Button onClick={() => handleFileOpen(4)} style={{height:'100px',width:'250px', backgroundColor:'#73A9AD', color:'white'}}>
                        <AttachFileIcon></AttachFileIcon>{t('lblDefectPhoto')}
                    </Button>
                </Grid>
          <FilePopup
          onClose={handleFileClose}
          ReceiptNo={ReceiptNo}
          DosyaTipi={DosyaTipi}
          DosyaTipiText={DosyaIsmi}
          open={openFile}
          CompFiles = {CompFiles}
        />
    </Grid >; 
      case 2:
        return <Grid container spacing={1}>
          <Grid item xs={12} sm={12} lg={12}>
          <Typography variant="overline" display="block" gutterBottom style={{color:'#13005A'}}>{t('lblIsManufacturingFault')}</Typography>
            <Typography variant="overline" display="block" gutterBottom>{ManufacturingFault}</Typography>
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
          <Typography variant="overline" display="block" gutterBottom style={{color:'#13005A'}}>{t('lblEngineerFindings')}:</Typography>
            <Typography variant="overline" display="block" gutterBottom>{EngineerFindings}</Typography>
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <Typography variant="overline" display="block" gutterBottom style={{color:'#13005A'}}>{t('lblDamageDetails')}:</Typography>
            <Typography variant="overline" display="block" gutterBottom>{DamageDetails}</Typography>
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
          <Typography variant="overline" display="block" gutterBottom style={{color:'#13005A'}}>{t('lblOtherInformation')}:</Typography>
            <Typography variant="overline" display="block" gutterBottom>{OtherInfo}</Typography>
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
          <Typography variant="overline" display="block" gutterBottom style={{color:'#13005A'}}>{t('lblFileInformation')}:</Typography>
            {files.filter(i => i.Type === 2 || i.Type === 3 || i.Type === 4 ).map(value => {
              return(
            <Typography variant="overline" display="block" gutterBottom>{value.TypeText} - {value.TypeCount} {t('lblAdet')}</Typography>)})}
          </Grid>
        </Grid>;
      default:
        return "Unknown stepIndex";
    }
  }


  return (
    <Page title=""> 
    <Card className={clsx(classes.root, className)}>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
        <Alert
          onClose={uyariKapat}
          message={responseMessage.ErrorDescription}
          variant={uyariTip}
        />
      </Snackbar>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CardHeader
          style={{ textAlign: 'left' }}
          title={t('lblCompensationForm')}
        />
        <Divider />
        <CardContent>
          <Stepper className={stepColor.root} activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
            {activeStep === steps.length ? (
              <div>
                <Typography className={classes.instructions}>
                  {responseMessage.ErrorDescription}
                </Typography>
                {/* <Button variant="contained" color="primary" onClick={handleReset}>{t('lblReset')}</Button> */}
              </div>
            ) : (
              <div>
                <Typography className={classes.instructions}>
                  {getStepContent(activeStep)}
                </Typography>
                <div style={{marginTop:'20px'}}>
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className={classes.backButton}
                  >
                    {t('lblBack')}
                  </Button>
                  <Button variant="contained" color="primary" onClick={handleNext}
                  >
                    {activeStep === steps.length - 1 ? <b>
                      {t('lblSave')}
                    </b> : t('lblNext')}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </CardContent>
                      
      </Card>
    </Page >
  );
}

CompensationForm.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    tasks: state.tasks1
  }),
  { setTask }
)(CompensationForm);

